export default "__VITE_ASSET__DKOVEAKl__"